exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-form td[data-v-7e013408]:last-child{border-right:none}.table-form .table-body tr[data-v-7e013408]:last-child{border:none}.table-form .table-body td[data-v-7e013408]:first-child{border-left:none}.table-form td[data-v-7e013408]{width:25%}[data-v-7e013408] .el-card .el-card__header{padding:10px}[data-v-7e013408] .custom-card{border-bottom:none!important}[data-v-7e013408] .el-card .el-card__header{padding:0!important}", ""]);

// exports
